import React from "react";
import Title from "../Title/Index";
import ImageTag from "../ImageTag/Index";
const Index = ({Data}) => {

  return (
    <>
      <section className="col-12 float-start accreditation">
        <div className="container">
          <div className="row">
            <div className="web-container">
              <Title secondHeading={"ACCREDITATION"} headingTwo={true}/>
            </div>
          </div>
        </div>
        <div className="col-12 float-start bglayerimage p-100">
          <div className="container">
            <div className="web-container">
              <div className="col-lg-10 col-12 m-auto">
                <div className="row">
                  {Data.accreditationData.map((item, index) => (
                    <div
                      key={index}
                      className="col-lg-4 col-sm-6 col-12"
                      data-aos="fade-in"
                      data-aos-offset="100"
                      data-aos-duration="500"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                     <div className="col-lg-11 m-auto col-12 bg-white text-center p-4 radius-25">
                     <ImageTag
                        ImagePath={item.imagePath}
                        ImageAlt={item.imageAlt}
                      />
                     </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Index;
